export default __webpack_public_path__ + "static/media/check-in-2-selected.03c16742.svg";